import React from 'react';
import { Button, Form, Input } from 'reactstrap';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

class Careers extends React.Component {
    render(){
        const today = new Date();
        const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const startDate = new Date(2026, 0, 20);
        const endDate = new Date(2026, 1, 16);
        const isOpen = currentDate >= startDate && currentDate <= endDate;

        return(
            <div align="center">
                <h1 className="H1">Careers</h1>
                <div className="p-3">
                    <Breadcrumb tag="nav" listTag="div">
                        <BreadcrumbItem tag="a" href="/">Home</BreadcrumbItem>
                        <BreadcrumbItem active tag="span">Careers</BreadcrumbItem>
                    </Breadcrumb>
                </div>
                {isOpen ? (
                    <div className="containerForm">
                        <p className="Font" align="left">
                            <b>ThothIT LLC</b> has <b>multiple openings</b> for the position of <b>Software Developer I</b> (Ref# SDI2026).
                            <br /><br />
                            <b>Work Location:</b> Irving, TX and relocation required to various unanticipated locations throughout the U.S.
                            <br /><br />
                            <b>Job Duties:</b> Under direct supervision, design, develop, implement, test, maintain, and support software applications and systems. Analyze user needs and develop software solutions for project/business requirements. Assist in all phases of the software development life-cycle (SDLC) following existing development processes. Enhance/optimize applications to meet client and company needs. Demonstrate knowledge in development methodologies, software design patterns, and software engineering best practices for the application of development domain areas and specific technologies and tool sets.
                            <br /><br />
                            <b>Requirements:</b> This position requires a Bachelor’s degree or foreign academic equivalent in Computer Science, Computer Engineering, Electrical/Electronics Engineering, Information Technology, Information Systems, Business/Data Analytics, or a related field. 40hrs/week.
                            <br /><br />
                            <b>Application Instructions:</b> To apply, please mail resume to the following address, ensuring to indicate the position reference code (Ref# SDI2026) for which you are applying. Mail to: ThothIT LLC, Attn: R. Pokhrel, Director, 8615 Freeport Parkway, Suite 175, Irving, TX 75063.
                        </p>
                    </div> ) 
                    : (
                        <p className="Font">No current openings.</p>
                    )}
            </div>
        )
    }
}

export default Careers;